module.exports = __webpack_public_path__ + "media/images/masks/avatar-group-2419b8065e5da2b42385d5a6baa899eeb1df8ef468dec5822c29584031fa56fd.svg";